import {
  APP_SETTING_FETCH_CSSDATA_BEGIN,
  APP_SETTING_FETCH_CSSDATA_SUCCESS,
  APP_SETTING_FETCH_CSSDATA_FAILURE,
  APP_SETTING_FETCH_CSSDATA_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function fetchCssdata(args = {}) {
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_FETCH_CSSDATA_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(args.url);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_FETCH_CSSDATA_SUCCESS,
            data: res.data,
            cssuuid: args.uuid,
            customCssCdnData: args.customCssCdnData,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_FETCH_CSSDATA_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchCssdataError() {
  return {
    type: APP_SETTING_FETCH_CSSDATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_FETCH_CSSDATA_BEGIN:
      return {
        ...state,
        fetchCssdataPending: true,
        fetchCssdataError: null,
      };

    case APP_SETTING_FETCH_CSSDATA_SUCCESS:
      return {
        ...state,
        fetchCssdataPending: false,
        fetchCssdataError: null,
        cssEditorValue: action.data,
        cssUuid: action.cssuuid,
        customCssCdnData: action.customCssCdnData,
        isOpenCssEditorModal: !state.isOpenCssEditorModal
          ? !state.isOpenCssEditorModal
          : state.isOpenCssEditorModal,
      };

    case APP_SETTING_FETCH_CSSDATA_FAILURE:
      return {
        ...state,
        fetchCssdataPending: false,
        fetchCssdataError: action.data.error,
      };

    case APP_SETTING_FETCH_CSSDATA_DISMISS_ERROR:
      return {
        ...state,
        fetchCssdataError: null,
      };

    default:
      return state;
  }
}
